<template>
  <div
    class="account-info-container"
  >
    <cube-form
      :model="model"
      @validate="validateHandler"
      @submit.prevent="submitHandler"
      @reset="resetHandler"
    >
      <cube-form-item :field="fields[0]" />
      <cube-form-item :field="fields[1]" />
      <cube-form-item :field="fields[2]" />
      <div class="form-btn-box">
        <cube-button
          type="reset"
          :light="true"
        >
          {{ $t('message["896"]') }}
        </cube-button>
        <cube-button
          type="submit"
          :primary="true"
        >
          {{ $t('message["915"]') }}
        </cube-button>
      </div>
    </cube-form>
  </div>
</template>
<script>

import { mapActions, mapState } from 'vuex'
export default {
  components: {
  },
  data () {
    return {
      validity: {},
      valid: undefined,
      model: {
        password: '',
        newpassword: '',
        renewpassword: ''
      },
      options: {
        scrollToInvalidField: true,
        layout: 'fresh' // classic fresh
      },
      fields: [
        {
          type: 'input',
          modelKey: 'password',
          label: this.$t('message["165"]'),
          props: {
            placeholder: this.$t('message["760"]'),
            type: 'password'
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'newpassword',
          label: this.$t('message["1342"]'),
          props: {
            placeholder: this.$t('message["751"]'),
            type: 'password'
          },
          rules: {
            required: true
          }
        },
        {
          type: 'input',
          modelKey: 'renewpassword',
          label: this.$t('message["1342"]'),
          props: {
            placeholder: this.$t('message["751"]'),
            type: 'password'
          },
          rules: {
            required: true,
            repeatValid: (val) => {
              return val === this.model.newpassword
            }
          },
          messages: {
            repeatValid: this.$t('message["608"]')
          }
        }
      ]
    }
  },
  computed: {
    ...mapState('account/modify', [''])
  },
  async mounted () {
  },
  methods: {
    ...mapActions('account/modify', ['modifyPassword']),
    async submitHandler (e) {
      const chain = await this.modifyPassword()
      chain.params(this.model)
        .onSuccess(res => {
          this.$router.replace({ name: 'AccountLogin' })
        })
        .onNetSuccess((res) => {
          const toast = this.$createToast({
            time: 2000,
            txt: res.data.message || res.data.payload[0].message,
            type: 'txt'
          })
          toast.show()
        })
        .config({ tip: false })
        .setForm(this.form)
        .fetch()
    },
    validateHandler (result) {
      this.validity = result.validity
      this.valid = result.valid
    },
    resetHandler () {
      this.$router.replace({ name: 'AccountInfo' })
    }
  }
}
</script>
<style lang="scss" scoped>
  .account-info-container::v-deep {
    padding-bottom: 60px;
    .cube-form-item {
      line-height: 56px;
      min-height: 56px;
       .cube-form-label {
        color: #888;
        font-size: 16px;
      }
    }
    .cube-form-item-box .find-pwd-box {
        top: 16px;
      }
  }
  .set-bind-box {
    padding-bottom: 0;
    height: 100%;
  }
</style>
